<template>
  <ThemedTextField
    v-model="text"
    outlined
    label="Search route"
    persistent-placeholder
    @input="onTextChanged(text)"
    dense
  />
</template>
  
  <script>
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "SearchRouteComponent",
  components: { ThemedTextField },
  data: function () {
    return {
      text: "",
    };
  },
  methods: {
    onTextChanged(text) {
      this.$store.dispatch(
        "weatherRouting/routesModule/filterRoutesByDescription",
        {
          description: text,
        }
      );
    },
  },
};
</script>